import { render, staticRenderFns } from "./form-code.vue?vue&type=template&id=c535778c&"
import script from "./form-code.vue?vue&type=script&lang=js&"
export * from "./form-code.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "form-code.vue"
export default component.exports